import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

// ==================================================================================
// ÍCONES SVG SUPREMOS (Low DPI / Traços Finos - Google Material Style)
// ==================================================================================
const Icons = {
  Logo: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
      <path d="M2 17l10 5 10-5"></path>
      <path d="M2 12l10 5 10-5"></path>
    </svg>
  ),
  WhatsApp: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
    </svg>
  ),
  Tag: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>,
  Glasses: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="6" cy="15" r="4"></circle><circle cx="18" cy="15" r="4"></circle><path d="M14 15a2 2 0 0 0-4 0"></path><path d="M2.5 13 5 7c.7-1.3 1.4-2 3-2"></path><path d="M21.5 13 19 7c-.7-1.3-1.5-2-3-2"></path></svg>,
  Users: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>,
  Building: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="9" y1="22" x2="9" y2="22"></line><line x1="15" y1="22" x2="15" y2="22"></line><path d="M9 6h6"></path><path d="M9 10h6"></path><path d="M9 14h6"></path><path d="M9 18h6"></path></svg>,
  ChevronRight: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>,
  TrendingUp: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 7 13 16 9 12 2 19"></polyline><polyline points="16 7 22 7 22 13"></polyline></svg>,
  Sparkles: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l1.912 5.813a2 2 0 001.272 1.272L21 12l-5.813 1.912a2 2 0 00-1.272 1.272L12 21l-1.912-5.813a2 2 0 00-1.272-1.272L3 12l5.813-1.912a2 2 0 001.272-1.272L12 3z"></path></svg>
};

export default function Home() {
  const [mounted, setMounted] = useState(false);
  const [whatsappStatus, setWhatsappStatus] = useState('loading');

  const user = JSON.parse(localStorage.getItem('vizumUser')) || { 
    nomeCompleto: 'Usuário', loja: 'Matriz', tipo: 'admin' 
  };

  const todayStr = new Intl.DateTimeFormat('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' }).format(new Date());

  const checkWhatsappStatus = useCallback(async () => {
    try {
      const response = await api.get('/api/whatsapp/status');
      setWhatsappStatus(response.data.connected ? 'connected' : 'disconnected');
    } catch (err) {
      console.error("Erro ao checar status:", err);
      setWhatsappStatus('disconnected');
    }
  },[]);

  useEffect(() => {
    setMounted(true);
    checkWhatsappStatus();
    
    // Força o modo claro (padrão SaaS Google Clean)
    document.body.setAttribute('data-theme', 'light');
    
    const interval = setInterval(checkWhatsappStatus, 20000); 
    return () => clearInterval(interval);
  },[checkWhatsappStatus]);

  function logout() {
    document.body.style.opacity = '0';
    setTimeout(() => {
      localStorage.clear();
      window.location.href = '/login';
    }, 400);
  }

  const getFirstName = (name) => name?.split(' ')[0] || 'Usuário';
  const getInitials = (name) => name?.slice(0, 2).toUpperCase() || 'LX';

  return (
    <div className="app-layout">
      <GlobalStyles />
      
      {/* HEADER (Google Topbar Style) */}
      <header className={`app-header ${mounted ? 'slide-down' : ''}`}>
        <div className="header-container">
          
          <div className="logo-section">
            <div className="logo-box"><Icons.Logo /></div>
            <span className="brand-title">Lumix OS</span>
          </div>

          <div className="header-actions">
            <div className="user-profile-wrapper">
              <div className="user-text desktop-only">
                <span className="user-name">{getFirstName(user.nomeCompleto)}</span>
                <span className="user-role">{user.loja}</span>
              </div>
              <div className="avatar-btn">
                 {getInitials(user.nomeCompleto)}
              </div>
              <button onClick={logout} className="btn-logout" title="Sair do sistema">
                 Sair
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* MAIN CONTENT */}
      <main className={`app-main ${mounted ? 'stagger-in' : ''}`}>
        
        {/* TOPO: Greeting + Status WPP */}
        <div className="top-dashboard-row stagger-item">
          <div className="greeting-section">
            <p className="greeting-date">{todayStr.charAt(0).toUpperCase() + todayStr.slice(1)}</p>
            <h1>Bem-vindo, <span>{getFirstName(user.nomeCompleto)}</span></h1>
          </div>

          <div className={`wpp-status-chip ${whatsappStatus}`}>
             <Icons.WhatsApp />
             <span>{whatsappStatus === 'connected' ? 'WhatsApp Ativo' : whatsappStatus === 'loading' ? 'Verificando...' : 'WhatsApp Desconectado'}</span>
             {whatsappStatus === 'connected' && <span className="status-dot online"></span>}
             {whatsappStatus === 'disconnected' && <span className="status-dot offline"></span>}
          </div>
        </div>

        {/* MÓDULOS DIVIDIDOS */}
        <div className="modules-wrapper stagger-item">
          
          <div className="module-group">
            <h2 className="group-title">Operação Diária</h2>
            <div className="module-grid">
              <AppCard title="Dashboard e Lançamentos" desc="O.S, Montagem, Financeiro e Fluxo" icon={<Icons.Glasses />} color="blue" href="/ordens-servico" isPrimary={true} />
              
              {/* CARD CRM PREMIUM */}
              <AppCardCRM />

              <AppCard title="Produtos & Lentes" desc="Cadastro de itens para venda" icon={<Icons.Tag />} color="yellow" href="/produtos" />
            </div>
          </div>

          {user.tipo === 'admin' && (
            <div className="module-group stagger-item">
              <h2 className="group-title">Gestão Corporativa</h2>
              <div className="module-grid">
                <AppCard title="Minhas Empresas" desc="Lojas, CNPJ e Configurações" icon={<Icons.Building />} color="neutral" href="/empresas" />
                <AppCard title="Acessos & Equipe" desc="Gerenciar usuários da rede" icon={<Icons.Users />} color="neutral" href="/cadastro" />
              </div>
            </div>
          )}

        </div>
      </main>

      <footer className="app-footer">
        <p>© {new Date().getFullYear()} Lumix OS • Gestão Suprema</p>
      </footer>
    </div>
  );
}

// ==================================================================================
// COMPONENTE APPCARD PADRÃO
// ==================================================================================
function AppCard({ title, desc, icon, color, href, isPrimary }) {
  const content = (
    <div className="card-content-inner">
      <div className="card-icon-area">
        <div className={`icon-surface color-${color}`}>{icon}</div>
      </div>
      <div className="card-text-area">
        <h3>{title}</h3>
        <p>{desc}</p>
      </div>
      <div className="card-action-area">
        <Icons.ChevronRight />
      </div>
    </div>
  );

  return (
    <a href={href} className={`app-card ${isPrimary ? 'primary-card' : ''}`}>
      {content}
    </a>
  );
}

// ==================================================================================
// COMPONENTE APPCARD CRM PREMIUM (Borda mágica, cores Google e Badge)
// ==================================================================================
function AppCardCRM() {
  return (
    <a href="/mensagens" className="app-card crm-card">
      <div className="crm-border-anim"></div>
      <div className="card-content-inner crm-inner">
        <div className="card-icon-area">
          <div className="icon-surface color-crm-premium"><Icons.TrendingUp /></div>
        </div>
        <div className="card-text-area">
          <div className="crm-title-row">
             <h3>Máquina de Vendas CRM</h3>
             <span className="badge-vendas"><Icons.Sparkles /> Alta Conversão</span>
          </div>
          <p>Automação de pós-venda, disparos inteligentes e histórico no WhatsApp.</p>
        </div>
        <div className="card-action-area">
          <Icons.ChevronRight />
        </div>
      </div>
    </a>
  );
}

// ==================================================================================
// ESTILOS GLOBAIS COM A PALETA DO GOOGLE CLOUD
// ==================================================================================
const GlobalStyles = () => {
  return (
    <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

    :root {
      /* Paleta Google Material 3 / Workspace */
      --bg: #F8FAFD;
      --surface: #FFFFFF;
      --surface-hover: #F1F3F4;
      
      --text-main: #202124;
      --text-sec: #5F6368;
      --text-muted: #9AA0A6;
      
      --border: #DADCE0;
      --border-soft: #F1F3F4;
      
      --google-blue: #1A73E8;
      --google-green: #1E8E3E;
      --google-red: #D93025;
      --google-yellow: #F9AB00;
      
      /* Cores dos Ícones Padrão Google */
      --c-blue: #1A73E8; --c-blue-bg: #E8F0FE;
      --c-yellow: #E37400; --c-yellow-bg: #FEF7E0;
      --c-neutral: #5F6368; --c-neutral-bg: #F1F3F4;
    }

    * { box-sizing: border-box; margin: 0; padding: 0; -webkit-tap-highlight-color: transparent; outline: none; }
    
    body, html { 
      min-height: 100dvh; font-family: 'Inter', -apple-system, sans-serif; color: var(--text-main); 
      background-color: var(--bg); transition: opacity 0.4s; overflow-x: hidden; font-size: 13px;
    }
    
    .app-layout { min-height: 100dvh; display: flex; flex-direction: column; }

    /* HEADER SUPREMO (Google Topbar) */
    .app-header { 
      background: var(--surface);
      border-bottom: 1px solid var(--border); position: sticky; top: 0; z-index: 100; 
      opacity: 0; transform: translateY(-10px); transition: all 0.5s ease;
      height: 60px;
    }
    .slide-down { opacity: 1; transform: translateY(0); }
    
    .header-container { max-width: 1100px; margin: 0 auto; height: 100%; padding: 0 20px; display: flex; justify-content: space-between; align-items: center; }
    
    .logo-section { display: flex; align-items: center; gap: 8px; cursor: pointer; color: var(--google-blue); }
    .brand-title { font-weight: 500; font-size: 18px; color: var(--text-main); letter-spacing: -0.5px; }
    
    .header-actions { display: flex; align-items: center; gap: 16px; }
    
    .user-profile-wrapper { display: flex; align-items: center; gap: 12px; }
    .user-text { display: flex; flex-direction: column; text-align: right; }
    .user-name { font-size: 13px; font-weight: 600; color: var(--text-main);}
    .user-role { font-size: 11px; color: var(--text-sec); font-weight: 500; margin-top: 2px;}
    
    .avatar-btn { width: 36px; height: 36px; border-radius: 50%; background: var(--google-blue); color: white; display: grid; place-items: center; font-size: 13px; font-weight: 600; }
    
    .btn-logout { background: transparent; border: 1px solid var(--border); color: var(--text-sec); padding: 6px 12px; border-radius: 6px; cursor: pointer; font-size: 12px; font-weight: 500; transition: 0.2s;}
    .btn-logout:hover { background: var(--surface-hover); color: var(--text-main); }

    /* MAIN CONTENT */
    .app-main { flex: 1; width: 100%; max-width: 1100px; margin: 0 auto; padding: 40px 20px; }
    
    /* ANIMAÇÃO CASCATA (STAGGER) */
    .stagger-in .stagger-item { opacity: 0; transform: translateY(15px); animation: staggerAnim 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
    .stagger-in .stagger-item:nth-child(1) { animation-delay: 0.05s; }
    .stagger-in .stagger-item:nth-child(2) { animation-delay: 0.15s; }
    .stagger-in .stagger-item:nth-child(3) { animation-delay: 0.25s; }
    @keyframes staggerAnim { to { opacity: 1; transform: translateY(0); } }

    /* TOPO: Saudação + Chip WPP */
    .top-dashboard-row { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 40px; flex-wrap: wrap; gap: 20px; }
    
    .greeting-date { font-size: 13px; font-weight: 500; color: var(--text-sec); margin-bottom: 6px; }
    .greeting-section h1 { font-size: 28px; font-weight: 400; color: var(--text-main); letter-spacing: -0.5px;}
    .greeting-section h1 span { font-weight: 600; }

    /* WPP STATUS CHIP (Google Filter Chip Style) */
    .wpp-status-chip { 
      display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; border-radius: 20px; 
      background: var(--surface); border: 1px solid var(--border); font-size: 13px; font-weight: 500;
      color: var(--text-sec); transition: 0.2s; box-shadow: 0 1px 2px rgba(0,0,0,0.02);
    }
    .wpp-status-chip svg { width: 16px; height: 16px; }
    
    .wpp-status-chip.connected { background: #E6F4EA; border-color: transparent; color: #137333; }
    .wpp-status-chip.connected svg { color: #1E8E3E; }
    .wpp-status-chip.disconnected { background: #FCE8E6; border-color: transparent; color: #A50E0E; }
    .wpp-status-chip.disconnected svg { color: #D93025; }

    .status-dot { width: 8px; height: 8px; border-radius: 50%; margin-left: 4px; }
    .status-dot.online { background: #1E8E3E; box-shadow: 0 0 0 2px #A7F3D0; }
    .status-dot.offline { background: #D93025; }

    /* MÓDULOS E GRIDS */
    .modules-wrapper { display: flex; flex-direction: column; gap: 32px; }
    .module-group { display: flex; flex-direction: column; gap: 16px; }
    .group-title { font-size: 13px; font-weight: 600; color: var(--text-sec); margin-bottom: 4px;}
    
    .module-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 16px; }

    /* CARDS SUPREMOS MATERIAL 3 */
    .app-card { 
      background: var(--surface); border: 1px solid var(--border); border-radius: 12px; padding: 20px; 
      text-decoration: none; display: flex; flex-direction: column; transition: 0.2s ease; 
      box-shadow: 0 1px 2px rgba(0,0,0,0.02); cursor: pointer; position: relative;
    }
    
    .app-card:hover { border-color: #BDC1C6; box-shadow: 0 4px 8px rgba(0,0,0,0.05); }
    .app-card:active { background: var(--surface-hover); }

    .primary-card { border-color: #8AB4F8; background: #F8FAFD; }
    .primary-card:hover { border-color: var(--google-blue); background: #E8F0FE; }

    /* ==================================================
       NOVO CARD DE CRM (Máquina de Vendas)
       ================================================== */
    .crm-card {
      overflow: hidden; border: none; background: #ffffff;
      box-shadow: 0 2px 8px rgba(0,0,0,0.04); padding: 2px; /* Espaço para a borda animada */
    }
    .crm-card:hover { box-shadow: 0 6px 16px rgba(26, 115, 232, 0.15); transform: translateY(-2px); }

    .crm-border-anim {
      position: absolute; inset: -50%; z-index: 0;
      background: conic-gradient(
        from 0deg,
        var(--google-blue), var(--google-red), var(--google-yellow), var(--google-green), var(--google-blue)
      );
      animation: spinBorder 4s linear infinite;
      opacity: 0.8;
    }
    @keyframes spinBorder { 100% { transform: rotate(360deg); } }

    .crm-inner { background: #ffffff; border-radius: 10px; padding: 18px; z-index: 1; height: 100%; display: flex; flex-direction: column;}
    .color-crm-premium { background: linear-gradient(135deg, #E8F0FE 0%, #FEF7E0 100%); color: var(--google-blue); }

    .crm-title-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; gap: 8px;}
    .badge-vendas { 
      display: inline-flex; align-items: center; gap: 4px; background: #FFF3E0; color: #E65100;
      font-size: 9px; font-weight: 700; text-transform: uppercase; padding: 3px 8px; border-radius: 12px;
      letter-spacing: 0.05em; border: 1px solid #FFE0B2;
    }
    .badge-vendas svg { width: 10px; height: 10px; }

    /* Elementos Internos Padrão */
    .card-content-inner { display: flex; flex-direction: column; height: 100%; position: relative;}
    
    .card-icon-area { margin-bottom: 16px; }
    .icon-surface { width: 44px; height: 44px; border-radius: 50%; display: grid; place-items: center; }
    
    /* Configuração das Cores de Ícones */
    .color-blue { background: var(--c-blue-bg); color: var(--c-blue); }
    .color-yellow { background: var(--c-yellow-bg); color: var(--c-yellow); }
    .color-neutral { background: var(--c-neutral-bg); color: var(--c-neutral); }

    .card-text-area { flex: 1; }
    .card-text-area h3 { font-size: 15px; font-weight: 500; color: var(--text-main); margin-bottom: 6px; }
    .crm-title-row h3 { margin-bottom: 0; }
    .card-text-area p { font-size: 13px; color: var(--text-sec); line-height: 1.4; font-weight: 400; }
    
    .card-action-area { position: absolute; right: 0; top: 0; color: var(--text-muted); opacity: 0; transition: 0.2s; }
    .app-card:hover .card-action-area { opacity: 1; transform: translateX(2px); }

    .app-footer { text-align: center; padding: 32px; font-size: 12px; color: var(--text-muted); font-weight: 500; }

    /* =========================================
       MOBILE RESPONSIVE
       ========================================= */
    .desktop-only { display: block; }
    
    @media (max-width: 768px) {
      .desktop-only { display: none !important; }
      
      .app-main { padding: 24px 16px; }
      .header-container { padding: 0 16px; }
      
      .top-dashboard-row { flex-direction: column; align-items: flex-start; gap: 16px; margin-bottom: 24px; }
      .greeting-section h1 { font-size: 24px; }
      
      /* TRANSFORMA O GRID EM LISTA ESTILO CONFIGURAÇÕES DO ANDROID/IOS */
      .module-grid { 
        display: flex; flex-direction: column; gap: 0; 
        background: var(--surface); border: 1px solid var(--border); border-radius: 16px; 
        overflow: hidden;
      }
      
      .app-card { 
        flex-direction: row; align-items: center; padding: 16px; 
        border: none; border-bottom: 1px solid var(--border-soft); border-radius: 0; 
        background: transparent; box-shadow: none;
      }
      .app-card:last-child { border-bottom: none; }
      .primary-card { background: #F8FAFD; border-bottom: 1px solid var(--border-soft);}
      
      .crm-card { padding: 1px; border-bottom: 1px solid var(--border-soft); border-radius: 0;}
      .crm-inner { flex-direction: row; align-items: center; padding: 15px; border-radius: 0; background: transparent; width: 100%;}
      .crm-border-anim { display: none; } /* Removemos a borda rodando no mobile para ficar clean */

      .app-card:hover { transform: none; box-shadow: none; background: var(--surface-hover); }
      .app-card:active { background: var(--border-soft); }
      
      .card-content-inner { display: flex; flex-direction: row; align-items: center; width: 100%; }
      
      .card-icon-area { margin-bottom: 0; margin-right: 16px; }
      .icon-surface { width: 40px; height: 40px; }
      
      .card-text-area h3 { font-size: 15px; margin-bottom: 2px; }
      .card-text-area p { font-size: 12px; }
      .crm-title-row { flex-direction: column; align-items: flex-start; gap: 2px;}
      
      .card-action-area { position: static; opacity: 1; transform: none; display: block; margin-left: auto; color: var(--border); }
    }
  `}</style>
  );
};